import { Col } from 'antd';
import React, { useContext } from 'react';
import type { DefaultTheme } from 'styled-components';
import { ThemeContext } from 'styled-components';
import LiveAnnouncer from './LiveAnnouncer';
import RowWrapper from './RowWrapper';

interface ChatRowWrapperProps {
  children: React.ReactNode;
  className?: string;
  isUser?: boolean;
  lastMessage?: {
    type: string;
    text: string;
    author: {
      __typename: string;
      name: string;
    };
  };
}

interface LayoutProps {
  chatLayout: boolean;
  isFullScreen: boolean;
}

const ChatRowWrapper = function ({
  children,
  className = undefined,
  lastMessage = undefined,
  isUser = false,
}: ChatRowWrapperProps) {
  const theme = useContext(ThemeContext) as DefaultTheme & LayoutProps;

  const width = (isUser && theme?.chatLayout) || theme?.isFullScreen ? 16 : 24;
  return (
    <RowWrapper className={className} justify="center">
      <LiveAnnouncer isUser={isUser} message={lastMessage} />
      <Col xs={24} xl={width}>
        {children}
      </Col>
    </RowWrapper>
  );
};

export default ChatRowWrapper;
